import { Box, Button, styled, Typography, useTheme } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NewMyReferral from './NewMyReferral';
import conObj from '../../utils/connection-assistant';
import MyClaim from './MyClaim';
import MyDownline from './MyDownline';
import useLocales from '../../hooks/useLocales';

const TypographyTitleStyled = styled(Typography)(({ theme, fontSize = 40, textAlign = 'center', mt = 6, mb = 4 }) => ({
  color: '#ffffff',
  fontWeight: 'bold',
  textAlign,
  fontSize,

  [theme.breakpoints.down('md')]: {
    fontSize: fontSize * 0.8,
  },

  [theme.breakpoints.down('sm')]: {
    fontSize: fontSize * 0.6,
    marginTop: mt * 0.7,
    marginBottom: mb * 0.7,
  },

  [theme.breakpoints.down('xs')]: {
    fontSize: fontSize * 0.5,
  },

  marginTop: mt,
  marginBottom: mb,
}));

const NewReferral = () => {
  const theme = useTheme();

  const navigate = useNavigate();

  const { translate } = useLocales();

  const [view, setView] = useState('referral');

  const [tableData, setTableData] = useState([]);

  const [referralData, setReferralData] = useState(null);

  useEffect(() => {
    getMemberReferral();
  }, []);

  const getMemberReferral = () => {
    conObj.post('members/referral.json').then((res) => {
      if (res.status === 200) {
        setReferralData(res.data?.data);
        setTableData(res.data?.data?.data);
      }
    });
  };

  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');

  useEffect(() => {
    if (tab === 'referral') {
      setView('referral');
    } else if (tab === 'claim') {
      setView('claim');
    } else if (tab === 'downline') {
      setView('downline');
    }
  }, [tab]);

  const getLabel = () => {
    if (view === 'referral') return translate('referral');
    if (view === 'claim') return translate('my_claim');
    return translate('downline');
  };

  const getTabStyles = (isActive) => ({
    width: '180px',
    backgroundColor: isActive ? '#ffd050' : 'transparent',
    color: isActive ? 'black' : 'white',
    border: '1px solid #ffd050',
    fontWeight: 'bold',
    borderRadius: '8px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: isActive ? '#ffc107' : 'rgba(255, 208, 80, 0.1)',
      borderColor: '#ffd050',
      color: isActive ? 'black' : '#ffd050',
    },
  });

  return (
    <Box paddingY={{ xs: 0, md: 6 }} display="flex" justifyContent="center">
      <Box
        width={{ xs: '100%', md: '1250px' }}
        sx={{
          overflowX: 'auto',
          border: '1px solid',
          borderImage: theme.palette.goldcity.gradient.main,
          borderImageSlice: 1,
          background: theme.palette.goldcity.gradient.secondary,
        }}
      >
        {/* Title */}
        <Box px={{ xs: 2, md: 20 }} py={2} sx={{ background: theme.palette.goldcity.gradient.secondary }}>
          <TypographyTitleStyled textAlign={'start'}>{getLabel()}</TypographyTitleStyled>
        </Box>

        {/* Tabs / Buttons */}
        <Box
          sx={{
            overflowX: 'auto',
            border: '1px solid',
            borderImage: theme.palette.goldcity.gradient.main,
            borderImageSlice: 1,
          }}
          bgcolor="black"
          px={{ md: 20 }}
          p={{ xs: 2 }}
        >
          <Box display="flex" gap={2}>
            <Box display="flex" gap={2}>
              <Button onClick={() => navigate('/referral?tab=referral')} sx={getTabStyles(view === 'referral')}>
                {translate('referral')}
              </Button>

              <Button onClick={() => navigate('/referral?tab=claim')} sx={getTabStyles(view === 'claim')}>
                {translate('my_claim')}
              </Button>

              <Button onClick={() => navigate('/referral?tab=downline')} sx={getTabStyles(view === 'downline')}>
                {translate('downline')}
              </Button>
            </Box>
          </Box>
        </Box>

        {/* Content */}
        <Box>
          {view === 'referral' && (
            <NewMyReferral tableData={tableData} referralData={referralData} getMemberReferral={getMemberReferral} />
          )}
          {view === 'claim' && <MyClaim />}
          {view === 'downline' && <MyDownline tableData={tableData} referralData={referralData} />}
        </Box>
      </Box>
    </Box>
  );
};

export default NewReferral;
